import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from "rxjs/operators";
import { MatSnackBar } from '@angular/material/snack-bar';
@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {
  constructor(private snackBar: MatSnackBar) { }
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
          if (evt instanceof HttpResponse) {
            if (evt.body.operation == 3) {
              let errorMsg = evt.body.messaggio[0] ? evt.body.messaggio[0] : "Errore generico";
              this.snackBar.open(errorMsg, 'close', { panelClass: 'errorSnack' });
            }
          }
          return evt;
        }),
        catchError((error: HttpErrorResponse) => {
          let errorMsg = 'Si è verificato un errore, si prega di riprovare più tardi.';
          if (error.error instanceof ErrorEvent) {
            // errorMsg = `Error: ${error.error.message}`;    
            this.snackBar.open(errorMsg, 'close', { panelClass: 'errorSnack' });
          } else {
            let message = error.message;
            if (error.status == 500) {
              message = 'Errore generico'
            }
            // errorMsg = `Error Code: ${error.status},  Message: ${message}`;
            this.snackBar.open(errorMsg, 'close', { panelClass: 'errorSnack' });
          }
          
          return throwError(() => error);
        }),

      )
  }
}
